export default {
  0: { background: "#ffebee", color: "#ba000d" },
  1: { background: "#f3e5f5", color: "#6a0080" },
  2: { background: "#e8eaf6", color: "#002984" },
  3: { background: "#e1f5fe", color: "#007ac1" },
  4: { background: "#e0f2f1", color: "#00675b" },
  5: { background: "#f1f8e9", color: "#5a9216" },
  6: { background: "#f9f7e3", color: "#c6a700" },
  7: { background: "#fff3e0", color: "#c66900" },
  8: { background: "#efebe9", color: "#4b2c20" },
  9: { background: "#eceff1", color: "#34515e" },
  10: { background: "#fce4ec", color: "#b0003a" },
  11: { background: "#ede7f6", color: "#320b86" },
  12: { background: "#e3f2fd", color: "#0069c0" },
  13: { background: "#e0f7fa", color: "#008ba3" },
  14: { background: "#e8f5e9", color: "#087f23" },
  15: { background: "#f9fbe7", color: "#99aa00" },
  16: { background: "#fff8e1", color: "#c79100" },
  17: { background: "#fbe9e7", color: "#c41c00" },
  18: { background: "#ffcdd2", color: "#ab000d" },
  19: { background: "#e1bee7", color: "#5c007a" },
  20: { background: "#c5cae9", color: "#00227b" },
  21: { background: "#b3e5fc", color: "#006db3" },
  22: { background: "#b2dfdb", color: "#005b4f" },
  23: { background: "#dcedc8", color: "#4b830d" },
  24: { background: "#fff9c4", color: "#a48900" },
  25: { background: "#ffe0b2", color: "#c25e00" },
  26: { background: "#d7ccc8", color: "#40241a" },
  27: { background: "#cfd8dc", color: "#29434e" },
  28: { background: "#f8bbd0", color: "#a00037" },
  29: { background: "#d1c4e9", color: "#280680" },
  30: { background: "#bbdefb", color: "#005cb2" },
  31: { background: "#b2ebf2", color: "#007c91" },
  32: { background: "#c8e6c9", color: "#00701a" },
  33: { background: "#f0f4c3", color: "#8c9900" },
  34: { background: "#ffecb3", color: "#c68400" },
  35: { background: "#ffccbc", color: "#b91400" },
  36: { background: "#f1f5ff", color: "#4272d7" },
  37: { background: "#f7f3ff", color: "#8058bd" },
  38: { background: "#deffc7", color: "#63ac46" },
  39: { background: "#f0faed", color: "#57b846" },
  40: { background: "#fff3ee", color: "#e45d27" },
  41: { background: "#fcf2fd", color: "#bd59d4" },
  42: { background: "#fff5f2", color: "#f87d6f" },
  43: { background: "#ebe7fb", color: "#846add" },
  44: { background: "#ffece9", color: "#fb8071" },
  45: { background: "#e4ecff", color: "#3568cc" },
  46: { background: "#f5eccc", color: "#764d00" },
  47: { background: "#eaf6f7", color: "#0099ac" },
  48: { background: "#cff9f3", color: "#009b8b" },
  49: { background: "#e5eff1", color: "#6b7375" }
};
